import React, { Fragment, PureComponent, memo } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

import { Button, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faPen, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import ToolkitProvider from "react-bootstrap-table2-toolkit";

import TablaFiltro from "../../../components/UI/tablaFiltro/tablaFiltroSort";
import Select from "../../../components/UI/Select/Select";
import ModalSeguridad from "../../Seguridad/ModalSeguridad.jsx";
import { Obtener_Estado_Active_Directory_Request } from '../../../request/ParametroRequest';
class ZonasItfz extends PureComponent {

    state = {
        activoAD: false,
        columnasZonas: [
            {
                dataField: "Id",
                text: "Id",
                hidden: false,
                sort: true,
                editable: false,
                align: "left"
            },
            {
                dataField: "CC_id",
                text: "CC_id",
                hidden: true,
                sort: false,
                editable: false,
                align: "left"
            },
            {
                dataField: "Nombre",
                text: "Nombre",
                hidden: false,
                sort: true,
                editable: false
            },
        ],
        cellEdit: {},
        selectRow: {},
        rowStyle: {},
        keyField: "Id"
    }

    componentDidMount = async () => {
        const selectRow = {
            clickToSelect: true,
            onSelect: this.props.onRowSelect,
            mode: "radio",
            style: { background: "#e2f3f9" },
            hideSelectColumn: true
        };
        this.obtenerEstadoActiveDirectory();
        this.setState({ selectRow });
    };
    obtenerEstadoActiveDirectory = async () => {
        const response = await Obtener_Estado_Active_Directory_Request();
        if (response.Exitoso) {
            this.setState({ activoAD: response.Datos });
        }
        else {
            Notificacion.error(response.Mensaje);
        }
    };

    render() {
        const { Datos, listaZonas, listaCallCenter, menuId, opcionValidar, showModalSeguridad,
            paginaActual, onPageChange, onSizePerPageChange } = this.props;

        const { columnasZonas, keyField, cellEdit, selectRow, rowStyle } = this.state;

        const rowEvents = { onDoubleClick: this.props.onDoubleClick };

        return (
            <ToolkitProvider
                keyField={keyField}
                data={listaZonas}
                columns={columnasZonas}
                search
            >
                {(props) => (
                    <Fragment>
                        <div className="container mt-3">
                            <div className="row">
                                <div className="col-12">
                                    <h1>{Datos.titulo}</h1>
                                </div>
                            </div>
                        </div>
                        <div className="container">
                            <div className="botones">
                                <Row>
                                    <Col>
                                        <Select
                                            id={Datos.CC_id.attributes.id}
                                            name={Datos.CC_id.attributes.id}
                                            labelText={Datos.CC_id.attributes.label}
                                            classNameContainer="form-group"
                                            className="form-control"
                                            value={Datos.CC_id.value}
                                            onChange={this.props.onSelectChanged}
                                            configuration={{
                                                valueField: "Id",
                                                textField: "Nombre",
                                                options: listaCallCenter
                                            }}
                                        />
                                    </Col>
                                    <Col className="text-right mt-4">
                                        <div className="tooltip2">
                                            <span className="tooltiptext2">Nuevo</span>
                                            <Button variant="primary" onClick={this.props.ingresarDatos}                      >
                                                <FontAwesomeIcon icon={faPlus} />
                                            </Button>
                                        </div>
                                        &nbsp;
                                        <div className="tooltip2">
                                            <span className="tooltiptext2">Editar</span>
                                            <Button variant="primary" onClick={this.props.actualizarDatos}>
                                                <FontAwesomeIcon icon={faPen} />
                                            </Button>
                                        </div>
                                        &nbsp;
                                        <div className="tooltip2">
                                            <span className="tooltiptext2">Eliminar</span>
                                            <Button variant="primary" onClick={this.props.handleBorrar}                      >
                                                <FontAwesomeIcon icon={faTrashAlt} />
                                            </Button>
                                        </div>
                                    </Col>
                                    <div class="col-3 text-right mt-4">
                                        <input
                                            type="text"
                                            onChange={this.props.filtrarRegistro}
                                            value={Datos.busqueda.value}
                                            className="form-control"
                                            placeholder="buscar"
                                        ></input>
                                    </div>
                                </Row>
                            </div>
                            <TablaFiltro
                                columnas={columnasZonas}
                                datos={listaZonas}
                                keyField={keyField}
                                modo={cellEdit}
                                rowEvents={rowEvents}
                                selectRow={selectRow}
                                rowStyle={rowStyle}
                                paginaActual={paginaActual}
                                onPageChange={onPageChange}
                                onSizePerPageChange={onSizePerPageChange}
                            />
                        </div>
                        <ModalSeguridad
                            token={this.props.token}
                            menuId={menuId}
                            opcionId={opcionValidar}
                            show={showModalSeguridad}
                            onActionResult={this.props.onActionResultModal}
                            onHide={this.props.handleCerrarModal}
                            activoAD={this.state.activoAD}
                        />
                    </Fragment>
                )}
            </ToolkitProvider>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.usuario.token,
        empresa: state.parametros.empresa
    };
};

export default connect(mapStateToProps)(withRouter(memo(ZonasItfz)));
